// extracted by mini-css-extract-plugin
export default {"icon":"PpWMx","icon--clearable":"HhFDp"};